module.exports = __webpack_public_path__ + "img/56.b91782be.jpg";